import { FC } from 'react';
import classNames from 'classnames';

import { DividerMode, DividerProps } from '@hh.ru/magritte-ui-divider/types';

import styles from './divider.less';

const genLengthStyles = (mode: DividerMode, length: number | undefined) => {
    if (!length) {
        return {};
    }

    if (mode === 'vertical') {
        return {
            height: `${length}px`,
        };
    }

    return {
        width: `${length}px`,
    };
};

export const Divider: FC<DividerProps> = ({
    mode = 'horizontal',
    marginTop = 0,
    marginRight = 0,
    marginLeft = 0,
    marginBottom = 0,
    length,
}) => {
    return (
        <div
            className={classNames({
                [styles.horizontal]: mode === 'horizontal',
                [styles.vertical]: mode === 'vertical',
            })}
            style={{
                ...genLengthStyles(mode, length),
                margin: `${marginTop}px ${marginRight}px ${marginBottom}px ${marginLeft}px`,
            }}
            role="separator"
            aria-orientation={mode}
        />
    );
};
